<div class="terminal-window" [style.height]="height">
  <div class="terminal-header">
    <span class="dot red"></span><span class="dot yellow"></span><span class="dot green"></span>
    <span class="terminal-title" [ngStyle]="{'color': title.includes('>_') ? '#27c93f' : '#ccc'}">
      {{ title }}
    </span>
  </div>
  
  <div class="terminal-body" #terminalBody>
    
    <div class="boot-sequence" *ngIf="!text">
      <p>>> Inicializando conexión segura con RAGPT...</p>
      <p>>> Cargando embeddings del contexto...</p>
      <p>>> Esperando respuesta del modelo <span class="cursor"></span></p>
    </div>

    <div class="output-container" *ngIf="text">
      <pre>{{ formattedText }}</pre><div class="cursor"></div>
    </div>

  </div>
</div>